/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MDIStrictHttpResponse } from '../../mdi-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProfessionModel } from '../../models/profession-model';

export interface ProfessionIdGet$Params {
  id: string;
}

export function professionIdGet(http: HttpClient, rootUrl: string, params: ProfessionIdGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<ProfessionModel>> {
  const rb = new RequestBuilder(rootUrl, professionIdGet.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MDIStrictHttpResponse<ProfessionModel>;
    })
  );
}

professionIdGet.PATH = '/Profession/{id}';
